<template>
    <div class="cg-left">
        <TopTabs :tabsObj="topTitle" />

        <div class="cg-left__content">
            <!-- <div>
                <div class="flex-center top-button" @click="addRequestForm">
                    {{ $t('chengguan.index.leftAside.applyForService') }}
                </div>
            </div> -->
            <div class="tabs">
                <!-- 网格巡查 -->
                <div v-if="searchForm.currentTab == 'grid'" class="tab-content" key="tab0">
                    <el-scrollbar class="tab-scrollbar">
                        <el-collapse v-if="gridGroupList && gridGroupList.length > 0" v-model="collapseExpandNames"
                            accordion @change="handleGridCollapseChange">
                            <el-collapse-item v-for="item in gridGroupList" :name="item.id" :key="item.id">
                                <template slot="title">
                                    <div class="flex-align-center">
                                        <el-checkbox v-model="item.checked"
                                            @change="handleCheckGrid($event, item)"></el-checkbox>
                                        <span style="margin-left: 4px">{{ item.label || item.name }}</span>
                                    </div>
                                </template>
                                <template v-if="item.taskList">
                                    <div v-for="(taskItem, index) in item.taskList" :key="index"
                                        class="collapse-list-item">
                                        <div class="flex-default">
                                            <div style="flex: 1; min-width: 0; overflow: hidden">
                                                <CustomMarquee :textLength="taskItem.name ? taskItem.name.length : 0">
                                                    {{ taskItem.name }}</CustomMarquee>
                                            </div>
                                            <div class="view-text" style="padding: 0 6px; flex-shrink: 0"
                                                @click.prevent="handleViewClick(taskItem)">
                                                查看
                                            </div>
                                        </div>

                                        <div class="time-text">{{ taskItem.planStartTime }}</div>
                                    </div>
                                </template>
                                <el-pagination v-if="item.taskList && item.taskList.length > 0"
                                    class="c-el-pagination-blue" small background align="center" :total="gridPage.total"
                                    :pageSize.sync="gridPage.pageSize" :currentPage.sync="gridPage.currentPage"
                                    layout="total,prev, pager, next" @current-change="getGridGroupTaskList(item.id)">
                                </el-pagination>
                                <CustomEmpty v-else>{{
                                    $t('chengguan.index.leftAside.noTaskData')
                                    }}</CustomEmpty>
                            </el-collapse-item>
                        </el-collapse>
                        <CustomEmpty v-else />
                    </el-scrollbar>
                </div>
                <!-- 正射影像 -->
                <div v-else-if="searchForm.currentTab == 'ortho'" class="tab-content" key="tab1">
                    <div class="search-wrap mg-bottom-16">
                        <el-input clearable v-model.trim.lazy="searchForm.keyWord" class="c-el-input-blue mg-bottom-8"
                            :placeholder="$t('chengguan.index.leftAside.enterName')">
                            <el-button class="btn-search" slot="append" icon="el-icon-search"
                                @click="getOrthoList(1)"></el-button>
                        </el-input>
                    </div>
                    <el-scrollbar class="tab-scrollbar-2">
                        <div v-if="zhengSheList.length > 0">
                            <el-checkbox-group ref="" v-model="checkedZhengShe" @change="handleCheckZhengSheChange">
                                <div v-for="item in zhengSheList" class="list-item">
                                    <div style="flex: 1">
                                        <el-checkbox :label="item.id" class="list-item__checkbox">
                                            <div>
                                                <div class="list-item__title">{{ item.name }}</div>
                                                <div class="list-item__time">{{ item.time }}</div>
                                            </div>
                                        </el-checkbox>
                                    </div>
                                    <span style="flex-shrink: 0; cursor: pointer"
                                        @click="handleZhengSheDingweiClick(item)">
                                        <i class="iconfont icon-dingwei"></i>
                                    </span>
                                </div>
                            </el-checkbox-group>
                        </div>
                        <CustomEmpty v-else />
                    </el-scrollbar>
                    <div>
                        <el-pagination class="c-el-pagination-blue" small background align="center"
                            :total="zhengShePage.total" :pageSize.sync="zhengShePage.pageSize"
                            :currentPage.sync="zhengShePage.currentPage" layout="total,prev, pager, next"
                            @current-change="getOrthoList">
                        </el-pagination>
                    </div>
                </div>
                <!-- 事件分布-->
                <div v-else-if="searchForm.currentTab == 'events'" class="tab-content" key="tab2">
                    <div class="search-wrap mg-bottom-16">
                        <el-input clearable v-model.trim.lazy="searchForm.keyWord" class="c-el-input-blue mg-bottom-8"
                            :placeholder="$t('chengguan.index.leftAside.enterName')">
                            <el-button class="btn-search" slot="append" icon="el-icon-search"
                                @click="getEventList(1)"></el-button>
                        </el-input>
                        <el-row :gutter="8" class="mg-bottom-8">
                            <el-col :span="12">
                                <el-cascader class="el-select-blue" v-model="searchForm.eventTypeId"
                                    :options="eventTypeOptions" :props="eventTypeCascaderProps"
                                    :placeholder="$t('chengguan.index.leftAside.eventType')" clearable
                                    popper-class="el-cascader__dropdown-blue"></el-cascader>
                            </el-col>
                            <el-col :span="12">
                                <el-select v-model="searchForm.eventStatus" class="el-select-blue"
                                    popper-class="c-el-select-dropdown-blue"
                                    :placeholder="$t('chengguan.index.leftAside.allStatuses')" clearable>
                                    <el-option v-for="item in eventStatusOptions" :key="item.dictValue"
                                        :label="item.dictLabel" :value="item.dictValue"></el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                    </div>
                    <el-scrollbar class="tab-scrollbar-3">
                        <div v-if="eventList.length > 0">
                            <EventListItem v-for="item in eventList" :key="item.id" :data="item"
                                @click="handleEventListClick">
                            </EventListItem>
                        </div>
                        <CustomEmpty v-else />
                    </el-scrollbar>
                    <div>
                        <el-pagination class="c-el-pagination-blue" small background align="center"
                            :total="eventsPage.total" :pageSize.sync="eventsPage.pageSize"
                            :currentPage.sync="eventsPage.currentPage" layout="total,prev, pager, next"
                            @current-change="getEventList">
                        </el-pagination>
                    </div>
                </div>
                <!-- 照片分布 -->
                <div v-else-if="searchForm.currentTab == 'photos'" class="tab-content" key="tab3">
                    <div class="search-wrap mg-bottom-16">
                        <el-row :gutter="8" class="mg-bottom-8">
                            <el-col :span="12">
                                <el-select v-model="pictureSearchForm.serviceOrderId" class="el-select-blue"
                                    popper-class="c-el-select-dropdown-blue"
                                    :placeholder="$t('hezhang.index.leftAside.selectionService')" clearable
                                    @visible-change="handleServicePageVisibleChange">
                                    <el-option v-for="item in serviceOrderOptions" :key="item.id" :label="item.label"
                                        :value="item.value"></el-option>
                                    <div class="service-select-pagination"
                                        v-if="servicePage.total > servicePage.pageSize">
                                        <el-pagination small layout="prev, pager, next"
                                            :current-page="servicePage.currentPage" :page-size="servicePage.pageSize"
                                            :total="servicePage.total"
                                            @current-change="handleServicePageChange"></el-pagination>
                                    </div>
                                </el-select>
                            </el-col>
                            <el-col :span="12">
                                <el-select v-model="pictureSearchForm.scopeGeometry" class="el-select-blue"
                                    popper-class="c-el-select-dropdown-blue"
                                    :placeholder="$t('hezhang.index.leftAside.shootingRange')" clearable>
                                    <el-option v-for="item in rangeOptions" :key="item.id" :label="item.label"
                                        :value="item.value"></el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                    </div>

                    <el-scrollbar class="tab-scrollbar-4">
                        <div v-if="currentPhotoPageData.length > 0">
                            <photoDistributionItem v-for="item in currentPhotoPageData" :key="item.id" :data="item"
                                :activeId="photoActiveId" @click="handlePhotoListClick"></photoDistributionItem>
                        </div>
                        <CustomEmpty v-else />
                    </el-scrollbar>
                    <div>
                        <el-pagination class="c-el-pagination-blue" small background align="center" :pager-count="5"
                            :total="photoPage.total" :pageSize.sync="photoPage.pageSize"
                            :currentPage.sync="photoPage.currentPage" layout="total,prev, pager, next"
                            @current-change="getPhotoPage">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

        <!-- 新增服务申请单 -->
        <el-dialog :title="addRequestFormDialog.title" :visible.sync="addRequestFormDialog.visible"
            :modal-append-to-body="false" :close-on-click-modal="false" :show-close="false" :destroy-on-close="true"
            custom-class="form-dialog" width="950px">
            <ServiceAddForm :appCode="appCode" id="" mode="add" @close="onDialogClose" />
        </el-dialog>
    </div>
</template>
<script>
import { nextTick } from 'vue-demi';
import TopTabs from '@/components/topTabs.vue';
import EventListItem from '@/components/events/EventListItem';
import ServiceAddForm from '@/page/service/iframe-form.vue';
import photoDistributionItem from '@/page/business/components/photoDistributionItem/index.vue';

import Api from '../../api';
import HZApi from '@/page/business/hezhang/api/index.js';
import serviceApi from '@/page/service/api.js';

import DicApi from '@/api/system/dic';
import DateUtil from '@/utils/DateUtil.js';
import DatepickerMixin from '@/mixins/datepicker.js';
import { getLayerSrcAndBbox } from '@/components/map/utils';
/**
 *
 * @description 左侧导航
 * emits: checkGrid 勾选网格分组,tabChange:切换tab
 */
export default {
    mixins: [DatepickerMixin],
    components: {
        TopTabs,
        EventListItem,
        ServiceAddForm,
        photoDistributionItem,
    },
    props: {
        onZhengSheData: {
            // 父组件通过传递这个函数去接收请求到的正射影像列表
            type: Function,
            default: () => { },
        },
        onPictureData: {
            // 父组件通过传递这个函数去接收请求到的照片列表
            type: Function,
            default: () => { },
        },
        onEventData: {
            // 父组件通过传递这个函数去接收请求到的事件列表
            type: Function,
            default: () => { },
        },
        searchForm: {
            // 父组件通过传递这个函数去接收请求到的事件列表
            type: Object,
            default: () => ({
                queryDate: [],
                eventTypeId: '',
                currentTab: '',
                eventStatus: '',
            }),
        },
        // 默认全选地图显示数据 ['events', 'photos', 'grid', 'ortho']
        tabControlList: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            topTitle: {},

            tabList: [], // mapTab标签列表

            addRequestFormDialog: { title: this.$t('service.list.titleAddForm'), visible: false },
            gridGroupList: [
                // {
                //     label: '网格分组一',
                //     id: '1',
                //     checked: true,
                //     taskList: [
                //     ],
                //     gridInfoList: [
                //         {
                //             "id": "1904011004190699522",
                //             "code": "082_082",
                //             "name": "网格_082_082",
                //             "description": null,
                //             "gridGroupId": "1904011003301507073",
                //             "geometryText": "MULTIPOLYGON (((113.15522855019108 23.043582127451373, 113.15522855018635 23.052565280318223, 113.16499190020185 23.052565280305387, 113.16499190020659 23.043582127438537, 113.15522855019108 23.043582127451373)))",
                //             "altitude": 190,
                //             "cameraZoom": 0,
                //             "row": 0,
                //             "col": 0,
                //             "hasRoute": "N",
                //             "siteId": null,
                //             "teamId": null,
                //             "areaId": null,
                //             "status": 0,
                //             "area": 997858.18,
                //             "statusText": null,
                //             "gridWaypointList": null,
                //             "visible": true
                //         }
                //     ]
                // },
            ],
            gridPage: {
                total: 0,
                pageSize: 10,
                currentPage: 1,
            },
            // 照片列表
            photoActiveId: null, // 当前激活的照片id
            photoList: [],
            rangeOptions: [], // 拍摄范围下拉框选项列表
            serviceOrderOptions: [], // 服务单下拉框选项列表
            pictureSearchForm: {
                serviceOrderId: '',
                scopeGeometry: '',
            },
            photoPage: {
                total: 0,
                pageSize: 10,
                currentPage: 1,
            },
            // 当前页要展示的数据
            currentPhotoPageData: [],
            servicePage: {
                total: 0,
                pageSize: 5,
                currentPage: 1,
            },

            // 正射影像列表
            zhengSheList: [],
            zhengShePage: {
                total: 0,
                pageSize: 10,
                currentPage: 1,
            },
            checkedZhengShe: [],
            // 事件类型下拉框选项
            eventTypeOptions: [],
            eventTypeCascaderProps: {
                label: 'name',
                value: 'id',
                emitPath: false,
            },
            // 事件状态下拉框选项
            eventStatusOptions: [],
            eventsPage: {
                total: 0,
                pageSize: 10,
                currentPage: 1,
            },

            eventList: [],
            // 默认展开的网格组
            collapseExpandNames: [],
        };
    },
    watch: {
        searchForm: {
            handler(newVal) {
                if (newVal.currentTab) {
                    this.topTitle = {
                        centre: this.$t(`businessConfig.control.${newVal.currentTab}`),
                        type: 3,
                    };
                    this.getFields(newVal.currentTab);
                }
                if (newVal.queryDate.length > 0) {
                    this.getEventList(1);
                    this.hzDataPicture();
                }
            },
            immediate: true,
            deep: true,
        },
        tabControlList: {
            handler(newVal, oldVal) {
                // eslint-disable-next-line no-param-reassign
                oldVal = oldVal || []; // 初始化旧值为空数组，避免首次加载时 undefined
                // 1. 找出新增的字段（新值有，旧值没有）
                const addedFields = newVal.filter((item) => !oldVal.includes(item));
                // 2. 找出移除的字段（旧值有，新值没有）
                const removedFieldList = oldVal.filter((item) => !newVal.includes(item));
                this.$nextTick(() => {
                    // 处理新增字段：请求对应接口
                    addedFields.forEach((field) => {
                        this.getFields(field);
                    });

                    // 处理移除字段：清空对应数据
                    removedFieldList.forEach((field) => {
                        this.removedFields(field);
                    });
                });
            },
            immediate: true,
            deep: true,
        },
        tabList: {
            handler(newVal) {
                // this.tabList = newVal;
            },
            immediate: true,
            deep: true,
        },
        pictureSearchForm: {
            handler(newVal) {
                this.hzDataPicture();
            },
            immediate: true,
            deep: true,
        },
    },
    computed: {
        appCode() {
            // 取当前所属应用，优先从路由参数中取，如果没有再从localStorage中取
            // 指定默认为：城管应用（CW）
            let appCode = this.$route.query.appCode || localStorage.getItem('appCode') || 'CW';
            return appCode;
        },

        pickerOptions() {
            return {
                ...this.mixinPickerOptions,
                onPick: ({ maxDate, minDate }) => {
                    // 当开始日期选中时，设置限制
                    if (minDate && !maxDate) {
                        const oneYearLater = new Date(minDate);
                        oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);
                        this.maxSelectableDate = oneYearLater;
                    } else {
                        this.maxSelectableDate = null;
                    }
                },
                disabledDate: (time) => {
                    const [start, end] = this.dateRange || [];
                    if (start && !end) {
                        const startTime = new Date(start).getTime();
                        const maxTime = new Date(start);
                        maxTime.setFullYear(maxTime.getFullYear() + 1);
                        return time.getTime() > maxTime.getTime();
                    }
                    return false;
                },
            };
        },
        checkedGridGroupList() {
            return this.gridGroupList.filter((item) => item.checked);
        },
    },
    methods: {

        // 根据地图中间字段获取数据
        getFields (field) {
            console.log('字段getFields：', field);

            // eslint-disable-next-line default-case
            switch (field) {
                case 'events':
                    this.getEventList(1); // 请求事件数据
                    break;
                case 'photos':
                    // 假设存在照片数据数组（根据实际业务补充）
                    console.log('照片数据：', this.currentPhotoPageData);
                    this.hzDataPicture(); // 请求照片数据
                    break;
                case 'grid':
                    this.getGridList(); // 请求网格数据
                    break;
                case 'ortho':
                    this.getOrthoList(1); // 请求正射影像数据
                    break;
            }
        },
        // 根据地图中间字段移除数据
        removedFields (field) {
            console.log('移除字段：', field);

            // eslint-disable-next-line default-case
            switch (field) {
                case 'events':
                    this.eventList = []; // 清空事件数据
                    this.eventsPage.total = 0; // 清空分页
                    this.onEventData([]);
                    break;
                case 'photos':
                    // 假设存在照片数据数组（根据实际业务补充）
                    this.photoList = [];
                    this.onPictureData([]);
                    break;
                case 'grid':
                    this.gridGroupList = []; // 清空网格数据
                    this.checkedGridGroupList = []; // 清空勾选状态
                    this.gridPage.total = 0; // 清空分页
                    this.$emit('checkGrid', []);
                    break;
                case 'ortho':
                    this.zhengSheList = []; // 清空正射影像数据
                    this.checkedZhengShe = []; // 清空勾选状态
                    this.zhengShePage.total = 0; // 清空分页
                    this.onZhengSheData([]);
                    break;
            }
        },

        handleTabCheckChange (tab, index, checked) {
            if (checked === undefined) {
                tab.checked = !tab.checked;
            }
            if (tab.value === 'grid') {
                this.handleCheckAllGrid(tab.checked);
            } else if (tab.value === 'ortho') {
                this.handleCheckAllOrtho(tab.checked);
            }
        },

        handleCheckAllGrid(val) {
            if (val) {
                this.gridGroupList.map((item) => (item.checked = true));
            } else {
                this.gridGroupList.map((item) => (item.checked = false));
            }
            this.emitCheckGrid();
        },
        // 勾选网格分组
        handleCheckGrid(event, item) {
            this.emitCheckGrid();
        },
        /**
         * 处理网格巡查日期选择器变化时的事件，去查询任务
         */
        handleGridDatePickerChange() {
            const gridGroupId = this.collapseExpandNames[0];
            if (gridGroupId) {
                this.getGridGroupData(gridGroupId);
            }
        },
        emitCheckGrid() {
            this.$emit('checkGrid', this.checkedGridGroupList);
            // if (this.gridGroupList.length > 0 && this.checkedGridGroupList.length === this.gridGroupList.length) {
            //     this.tabList[0].checked = true;
            // }
        },
        /**
         * 处理网格分组定位图标点击事件
         *
         * @param {Object} item - 被点击的网格分组对象
         */
        handleGridDingweiClick(item) {
            this.$emit('gridDingweiClick', item);
        },
        handleViewClick(task) {
            const { gridGroupId, gridId, id } = task;
            // 跳转到网格详情页面，并传递网格分组ID和网格ID作为查询参数
            this.$router.push({
                path: '/chengguan/dailypatrol',
                query: {
                    gridGroupId,
                    gridId,
                    taskId: id,
                    // 关键：将数组转为JSON字符串，避免路由自动序列化为对象
                    queryDate: JSON.stringify(this.searchForm.queryDate),
                },
            });
        },
        /**
         * 处理全选或全不选 正射影像列表
         *
         * @param {boolean} val - 是否全选，true 为全选，false 为全不选
         */
        handleCheckAllOrtho(val) {
            if (val) {
                this.checkedZhengShe = this.zhengSheList.map((item) => item.id);
            } else {
                this.checkedZhengShe = [];
            }
            this.handleCheckZhengSheChange();
        },
        handleCheckZhengSheChange() {
            let result = this.zhengSheList.filter((item) => this.checkedZhengShe.includes(item.id));
            this.$emit('checkZhengShe', result);
        },
        /**
         * 处理正射影像列表定位图标点击
         *
         * @param {Object} item - 被勾选的正射影像对象
         */
        handleZhengSheDingweiClick(item) {
            this.$emit('zhengSheDingweiClick', item);
        },

        /**
         * 处理事件列表点击事件
         *
         * @param item 点击的事件项
         */
        handleEventListClick(item) {
            this.$emit('eventListClick', item);
        },
        /**
         * 处理表格折叠变化事件
         *
         * @param gridGroupId 网格分组ID
         */
        handleGridCollapseChange(gridGroupId) {
            if (gridGroupId) {
                this.gridPage.currentPage = 1;
                if (typeof gridGroupId === 'string') {
                    this.getGridGroupData(gridGroupId);
                }
            }
        },
        addRequestForm() {
            this.addRequestFormDialog.visible = true;
        },
        onDialogClose() {
            this.addRequestFormDialog.visible = false;
        },
        /**
         * 获取网格列表
         *
         * @returns {Promise<Array>} 返回一个包含任务列表的Promise对象
         */
        getGridList() {
            let param = {};
            Api.fetchGridList(param).then((res) => {
                let resultList = [];
                if (res.code === 200) {
                    let list = res.data || [];
                    list.forEach((item, index) => {
                        const gridGroup = item.gridGroup || {};
                        let obj = { ...item, ...gridGroup };
                        obj.checked = false;
                        delete obj.gridGroup;
                        resultList.push(obj);
                        if (index == 0) {
                            obj.checked = true;
                            this.collapseExpandNames = [obj.id];

                            this.getGridGroupData(obj.id);
                        }
                    });

                    this.gridGroupList = resultList;

                    this.emitCheckGrid();
                }
            });
        },

        getGridGroupData(gridGroupId) {
            this.getGridGroupTaskList(gridGroupId);
            this.getGridGroupStats(gridGroupId);
        },
        /**
         * 获取网格组日常巡查任务列表
         */
        getGridGroupTaskList(gridGroupId) {
            if (!gridGroupId) return;
            let param = {
                startTime: this.searchForm.queryDate[0],
                endTime: this.searchForm.queryDate[1],
                gridGroupId,
                pageNum: this.gridPage.currentPage,
                pageSize: this.gridPage.pageSize,
            };

            if (!this.validateSearchTime(param)) {
                return;
            }

            Api.fetchGridGroupTaskList(param).then((res) => {
                if (res.code === 200) {
                    let resData = res.data || {};
                    this.gridPage.total = resData.total || 0;
                    let gridGroup = this.gridGroupList.find((item) => item.id == gridGroupId);
                    if (gridGroup) {
                        let list = resData.rows || [];
                        this.$set(gridGroup, 'taskList', list);
                    }
                }
            });
        },
        /**
         * 获取网格组单元格统计信息
         */
        getGridGroupStats(gridGroupId) {
            let self = this;
            if (!gridGroupId) return;
            let param = {
                startTime: this.searchForm.queryDate[0],
                endTime: this.searchForm.queryDate[1],
                gridGroupId,
            };

            if (!this.validateSearchTime(param)) {
                return;
            }

            Api.fetchGridGroupStats(param).then((res) => {
                if (res.code === 200) {
                    let resData = res.data || [];
                    // 转换为map，方便根据id查询,这样效率比较快，方便后续操作
                    let statsDataMap = {};
                    resData.forEach((item) => {
                        statsDataMap[item.id] = item;
                    });
                    let gridGroup = this.gridGroupList.find((item) => item.id == gridGroupId);
                    if (gridGroup) {
                        let gridInfoList = gridGroup.gridInfoList || [];
                        gridInfoList.forEach((item) => {
                            const gridId = item.id;
                            let taskNum = '';
                            let flightNum = '';
                            let eventNum = '';
                            if (statsDataMap[gridId]) {
                                taskNum = statsDataMap[gridId].taskNum || '';
                                flightNum = statsDataMap[gridId].flightNum || '';
                                eventNum = statsDataMap[gridId].eventNum || '';
                            }
                            self.$set(item, 'taskNum', taskNum);
                            self.$set(item, 'flightNum', flightNum);
                            self.$set(item, 'eventNum', eventNum);
                        });
                    }
                }
            });
        },
        /**
         * 获取正射地图列表
         */
        getOrthoList(page) {
            let pageNum = page || 1;

            this.zhengShePage.currentPage = pageNum;

            let param = {
                // startTime: this.searchForm.queryDate[0],
                beginTime: this.searchForm.queryDate[0],
                endTime: this.searchForm.queryDate[1],
                name: this.searchForm.keyWord,
                pageNum: this.zhengShePage.currentPage,
                pageSize: this.zhengShePage.pageSize,
            };
            Api.fetchOrthoList(param).then((res) => {
                let resList = [];
                let total = 0;
                if (res.code === 200) {
                    total = res.total || 0;
                    resList = res.rows || [];
                }
                resList.forEach((item) => {
                    let info = getLayerSrcAndBbox(item);

                    if (info) {
                        Object.assign(item, { ...info, zIndex: 100 });
                    }
                });
                this.zhengShePage.total = total;
                this.zhengSheList = resList;

                if (typeof this.onZhengSheData === 'function') {
                    this.onZhengSheData(JSON.parse(JSON.stringify(resList)));
                }
            });
        },
        /**
         * 获取事件列表
         */
        getEventList(page) {
            let pageNum = page || 1;

            this.eventsPage.currentPage = pageNum;

            let param = {
                startTime: this.searchForm.queryDate[0],
                endTime: this.searchForm.queryDate[1],
                name: this.searchForm.keyWord,
                pageNum: this.eventsPage.currentPage,
                pageSize: this.eventsPage.pageSize,
            };
            if (this.searchForm.eventStatus) {
                param.status = this.searchForm.eventStatus;
            }
            if (this.searchForm.eventTypeId) {
                param.eventTypeId = this.searchForm.eventTypeId;
            }

            if (!this.validateSearchTime(param)) {
                return;
            }
            Api.fetchEventList(param).then((res) => {
                let resList = [];
                let total = 0;
                if (res.code === 200) {
                    total = res.total || 0;
                    resList = res.rows || [];
                }
                this.eventsPage.total = total;
                this.eventList = resList;
                if (typeof this.onEventData === 'function') {
                    this.onEventData(JSON.parse(JSON.stringify(resList)));
                }
            });
        },
        handlePhotoListClick(item) {
            this.$emit('eventListClick', item);
            this.photoActiveId = item.id;
        },

        /**
         * 查询河湖岛+工程列表
         */
        getWaterAreahzList() {
            HZApi.waterAreahzList().then((res) => {
                if (res.code !== 200) {
                    this.rangeOptions = [];
                } else {
                    let list = this.getRangeList(res.data);
                    this.rangeOptions = list || [];
                }
            });
        },

        /**
         * 获取图片列表
         */
        async hzDataPicture () {
            if (this.searchForm.queryDate.length === 0) return;
            let param = {
                beginTime: this.searchForm.queryDate[0],
                endTime: this.searchForm.queryDate[1],
                appCode: this.appCode,
                ...this.pictureSearchForm,
            };
            Api.taskDataPictureList(param).then((res) => {
                if (res.code === 200) {
                    this.photoList = res.data || [];
                    this.photoPage.total = res.data.length || 0;
                    if (typeof this.onPictureData === 'function') {
                        this.onPictureData(JSON.parse(JSON.stringify(res.data)));
                    }
                    this.getCurrentPageData(); // 重新计算当前页数据
                }
            });
        },
        // 计算当前页数据
        getCurrentPageData() {
            const { currentPage, pageSize } = this.photoPage;
            // 计算截取的起始索引和结束索引
            const startIndex = (currentPage - 1) * pageSize;
            const endIndex = startIndex + pageSize;
            // 截取原始数据，得到当前页数据
            this.currentPhotoPageData = this.photoList.slice(startIndex, endIndex);
        },

        getPhotoPage(page) {
            this.photoPage.currentPage = page;
            this.getCurrentPageData(); // 重新计算当前页数据
        },
        async getListServiceOrder() {
            let param = {
                pageNum: this.servicePage.currentPage,
                pageSize: this.servicePage.pageSize,
            };
            const res = await serviceApi.listServiceOrder(param);
            let list = res.rows || [];
            if (list.length > 0) {
                this.serviceOrderOptions = list.map((item) => ({ id: item.id, value: item.id, label: item.name }));
            }
            this.servicePage.total = res.total;
        },

        // 分页查询服务单
        handleServicePageChange(num) {
            this.servicePage.currentPage = num;
            this.getListServiceOrder();
        },

        handleServicePageVisibleChange() {
            this.servicePage.currentPage = 0;
            this.getListServiceOrder();
        },
        /**
         * 验证搜索时间参数是否合法
         *
         * @param param 参数对象，包含 startTime 和 endTime 属性
         * @returns 如果 startTime 和 endTime 均存在则返回 true，否则返回 false
         */
        validateSearchTime (param) {
            if (!param) return false;

            if (!param.startTime) {
                this.$message.error(this.$t('common.startDateRequired'));
                return false;
            } else if (!param.endTime) {
                this.$message.error(this.$t('common.endDateRequired'));
                return false;
            }
            if (param.startTime) {
                param.startTime += ' 00:00:00';
            }
            if (param.beginTime) {
                param.beginTime += ' 00:00:00';
            }
            // param.startTime += " 00:00:00"
            param.endTime += ' 23:59:59';
            return true;
        },
        /**
         * 获取事件状态字典
         */
        getEventStatusDic() {
            DicApi.fetchEventStatusDic().then((res) => {
                this.eventStatusOptions = res.data || [];
            });
        },
        getEventTypeTree() {
            Api.fetchEventTypeTree().then((res) => {
                if (res.code === 200) {
                    this.eventTypeOptions = res.data || [];
                }
            });
        },
        // 照片拍摄范围处理
        getRangeList(val) {
            let resultList = [];
            // 定义需要处理的子列表名称（对应 val 中的 key）
            const targetLists = ['riverList', 'lakeList', 'islandList', 'projectList'];
            // 遍历所有需要处理的子列表
            targetLists.forEach((listKey) => {
                // 检查当前子列表是否存在且为数组
                const currentList = val[listKey];
                if (!Array.isArray(currentList)) return; // 若子列表不存在/非数组，跳过
                // 遍历当前子列表的每一项，提取所需字段
                currentList.forEach((item) => {
                    // 检查 item 是否包含必要字段（避免异常）
                    if (item?.id && item?.name !== undefined && item?.geometry !== undefined) {
                        resultList.push({
                            label: item.name, // 对应名称字段
                            value: item.geometry, // 对应几何信息字段
                            id: item.id, // 对应唯一ID字段
                        });
                    }
                });
            });
            return resultList;
        },
    },
    created() {
        this.getEventStatusDic();
        this.getEventTypeTree();
        this.getWaterAreahzList();
    },
    mounted() {
        this.getGridList();
        // this.getEventList();
    },
};
</script>
<style lang="scss" scoped>
$topTitleHeight: 65px;
$topButtonHeight: 36px;
$tapItemHeight: 32px;
$colorLightBlue: #49f0fd;

.cg-left {
    height: 100%;
    position: relative;

    &__content {
        padding: 16px;
        padding-top: 0px;
        // height: calc(100% - #{$topTitleHeight});
        height: 100%;

        .top-button {
            height: $topButtonHeight;
            color: #071150;
            background: linear-gradient(181deg, #1dc9ff 0%, #49f0fd 100%);
            border-radius: 2px 2px 2px 2px;
            margin-bottom: 16px;
            cursor: pointer;
        }

        ::v-deep .el-checkbox {
            &__inner {
                background-color: transparent;
                border-color: $colorLightBlue;
            }

            &__input.is-checked {
                .el-checkbox__inner::after {
                    border-color: $colorLightBlue;
                }
            }
        }
    }

    .tabs {
        position: relative;
        // height: calc(100% - #{$topButtonHeight} - 16px);
        height: 100%;

        &__header {
            // display: flex;
            display: block;
            box-sizing: border-box;
            //margin-bottom: 16px;
        }

        &__header-item {
            // flex: 1;
            min-width: 94px;
            padding: 0 6px;
            display: inline-flex;
            box-sizing: border-box;
            align-items: center;
            justify-content: center;
            height: $tapItemHeight;
            text-align: center;
            background: linear-gradient(180deg, rgba(7, 17, 80, 0.33) 0%, rgba(15, 60, 170, 0.31) 100%);
            border-radius: 1px 1px 1px 1px;
            border: 1px solid;
            border-image: linear-gradient(180deg, rgba(73, 240, 253, 0), rgba(73, 240, 253, 0.3)) 1 1;
            cursor: pointer;

            &.is-active {
                color: #49f0fd;
                background: linear-gradient(180deg, #071150 0%, #0f3caa 100%);
                box-shadow: inset 0px -3px 4px 0px rgba(153, 255, 255, 0.2);
                border-radius: 1px 1px 1px 1px;
                border: 1px solid;
                border-image: linear-gradient(180deg, rgba(73, 240, 253, 0), rgba(73, 240, 253, 1)) 1 1;
            }
        }

        .tab-content {
            position: relative;
            height: calc(100% - #{$tapItemHeight} - 16px);
        }

        .tab-scrollbar {
            $searchHeight: 32px;
            height: calc(100% - #{$searchHeight});
        }

        .tab-scrollbar-2 {
            $searchHeight: 72px;
            $pageHeight: 30px;
            height: calc(100% - #{$searchHeight} - #{$pageHeight});
        }

        .tab-scrollbar-3 {
            $searchHeight: 112px;
            $pageHeight: 30px;
            height: calc(100% - #{$searchHeight} - #{$pageHeight});
        }
        .tab-scrollbar-4 {
            height: calc(100% - 85px);
        }
        ::v-deep {

            .tab-scrollbar,
            .tab-scrollbar-2,
            .tab-scrollbar-3,
            .tab-scrollbar-4
             {
                .el-scrollbar__wrap {
                    overflow-x: hidden;
                }

                .el-scrollbar__thumb {
                    position: relative;

                    &::before {
                        content: '';
                        position: absolute;
                        top: 0px;
                        left: 0px;
                        right: 0px;
                        bottom: 0px;
                        background: linear-gradient(to bottom,
                                rgba(73, 240, 253, 1),
                                rgba(73, 240, 253, 0.4),
                                rgba(73, 240, 253, 0.4),
                                rgba(73, 240, 253, 1));
                        border-radius: inherit;
                        z-index: -1;
                    }

                    &::after {
                        content: '';
                        position: absolute;
                        top: 1px;
                        left: 1px;
                        right: 1px;
                        bottom: 1px;
                        background: rgba(7, 17, 80, 0.8);
                        border-radius: inherit;
                        z-index: 1;
                    }
                }
            }
        }

        ::v-deep .el-collapse {
            border-top: none !important;
            border-bottom: none !important;

            &-item {
                &__header {
                    color: #ffffff;
                    background-color: transparent;
                    border-bottom: none !important;
                    height: 32px;
                    line-height: 32px;
                }

                &__wrap {
                    background-color: transparent;
                    border-bottom: none;
                }

                &__arrow {
                    color: #49f0fd;
                }

                &__content {
                    color: #ffffff;
                    padding-bottom: 12px;
                }
            }
        }

        .list-item {
            display: flex;
            box-sizing: border-box;
            align-items: center;
        }

        .collapse-list-item,
        .list-item {
            padding: 6px 8px;
            background: #112d7b;
            border-radius: 2px 2px 2px 2px;
            border: 1px solid #1a47a4;
            font-size: 14px;

            &:not(:last-child) {
                margin-bottom: 8px;
            }

            &:hover,
            &.is-active {
                background: #1a47a4;
            }

            .view-text {
                color: $colorLightBlue;
                cursor: pointer;
            }

            .time-text {
                color: rgba(255, 255, 255, 0.6);
                font-size: 12px;
            }
        }

        .list-item__checkbox {
            display: flex;
            box-sizing: border-box;
            align-items: center;
            color: rgba(255, 255, 255, 0.9);
        }

        .list-item {
            &__title {
                color: rgba(255, 255, 255, 0.9);
            }

            &__time {
                color: #a1a1a1;
            }
        }
    }
}

/* 分页容器（限定在service-select-pagination内） */
.service-select-pagination .el-pagination {
    /* 调整分页整体文字颜色 */
    color: #ffffff;
    /* 基础文字色 */
    background-color: #1a47a4;
}

/* 页码按钮默认样式 */
::v-deep .el-pager li {
    color: #ffffff;
    /* 页码文字色 */
    border-color: #d1d9e6;
    /* 边框色 */
    background-color: #1a47a4;
    /* 背景色 */
}

::v-deep .el-pager li.active {
    background-color: #49f0fd !important;
}

/* 页码按钮 hover 状态 */
.service-select-pagination .el-pager li:not(.disabled):hover {
    color: #2783fb;
    /*  hover文字色 */
    border-color: #b8d1f3;
    /*  hover边框色 */
    background-color: #071150;
    /*  hover背景色 */
}

/* 当前页码按钮（核心突出样式） */
::v-deep .service-select-pagination .el-pager li.active {
    color: #fff;
    /* 当前页文字色（白色更醒目） */
    background-color: #49f0fd !important;
    /* 当前页背景色（主色调） */
    border-color: #49f0fd !important;
    /* 当前页边框色（与背景一致） */
}

/* 禁用状态（上一页/下一页/页码） */
::v-deep .el-pagination button:disabled,
::v-deep .el-pager li.disabled {
    color: #c9cdD4;
    /* 禁用文字色 */
    border-color: #e5e6eb;
    /* 禁用边框色 */

    background-color: #2783fb !important;
    /* 禁用背景色 */
}

::v-deep .btn-prev,
::v-deep .btn-next {
    background-color: #2783fb !important;
    color: #ffffff;
    padding: 0 8px;
}

::v-deep .el-dialog {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    margin-top: 0 !important;
    background: #071150;
    box-shadow: inset 0px 0px 10px 0px #49f0fd;
    border: 1px solid #49f0fd;

    .el-dialog__header {
        padding: 18px 0 18px 24px;
        border-bottom: 1px solid #49f0fd;
        box-shadow: inset 0px 0px 10px 0px #49f0fd;

        .el-dialog__title {
            height: 21px;
            font-size: 16px;
            font-weight: 400;
            color: #49f0fd;
            line-height: 19px;
        }
    }

    .el-dialog__body {

        .el-input__inner,
        .el-textarea__inner {
            background-color: #071150;
            border: 1px solid rgba(135, 161, 216, 0.7);
            color: #fff;
        }

        .el-form-item.is-error .el-input__inner {
            border-color: #f56c6c;
        }

        .upload-demo {
            width: 750px;
        }

        .el-upload-dragger {
            background: #071150;
            width: 769px;
        }

        .el-form-item__label {
            color: #fff !important;
            font-size: 14px;
        }

        .el-button {
            width: 144px;
            height: 34px;
            font-size: 14px;
            background: rgba(73, 240, 253, 0.2);
            border-radius: 2px 2px 2px 2px;
            border: 1px solid #49f0fd;
        }

        .el-button--primary {
            color: #fff;
        }

        .el-button--primary:hover {
            color: #409eff;
        }
    }

    &.form-dialog {
        .el-dialog__body {
            padding: 0px;
        }
    }

    .fix-close {
        position: absolute;
        top: -20px;
        right: -20px;
        cursor: pointer;
    }
}
</style>
